import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UploadReqStepJobBoardsComponent } from './upload-req-step-job-boards.component';
import { JobBoardsSupportedParametersModule } from '../../candidate-job-matches-workflow-page/add-candidates-from-job-boards/job-boards-supported-parameters/job-boards-supported-parameters.module';

@NgModule({
  declarations: [UploadReqStepJobBoardsComponent],
  imports: [
    CommonModule,
    FormsModule,
    JobBoardsSupportedParametersModule
  ],
  exports: [UploadReqStepJobBoardsComponent],
  entryComponents: [UploadReqStepJobBoardsComponent]
})
export class UploadReqStepJobBoardsModule { }
